export enum deviceFmtEnum {
  N62 = 'indexed8',
  N62S = 'indexed8',
  O62 = 'indexed8',
  P62 = 'indexed8',
  K62 = 'argb8888',
  K63 = 'argb8888',
  K65 = 'rgb565_a',
  K67 = 'rgb565_a',
  M62 = 'argb8888',
  M65S = 'argb8888',
  N65 = 'indexed8',
  N65A = 'indexed8',
  N65B = 'indexed8',
  M66 = 'argb8888',
  M67 = 'argb8888',
  L61 = 'argb8888',
  L61Simulator = 'argb8888',
  K65A = 'rgb565swap_a',
  L65 = 'argb8888',
  L67 = 'argb8888',
  N60 = 'argb8888'
}

export enum fmtIndexEnum {
  argb8888 = 0 /* 32bit per pixel*/,
  xrgb8888 = 1 /* 32bit per pixel without alpha value. */,

  /**
   * 32bit per pixel with MSB byte set to zero, the alpha value is appended to
   * end of image data seperately. 8bit per alpha value.
   */
  xrgb8888_a = 2,
  rgb565 = 3 /* 16bit per pixel without alpha */,

  /* 16bit per pixel, with alpha value appended to end of image data. */
  rgb565_a = 4,

  axrgb88565 = 5 /* 32bit per pixel, alpha uses 8bit, RGB takes 16bit. */,
  argb8565 = 6 /* 24bit per pixel with alpha */,

  /**
   * RGB565 16bit color in big endian with alpha valueappended to end of
   * image data.
   */
  rgb565swap_a = 7,
  rgb565swap = 8 /* 16bit per color in big endian with no alpha. */,

  alpha1 = 9 /* 1bit per pixel, only alpha, follow lvgl standard. */,
  alpha2 = 10 /* 2bit per pixel, only alpha */,
  alpha4 = 11 /* 4bit per pixel, only alpha */,
  alpha8 = 12 /* 8bit per pixel, only alpha */,

  indexed1 = 13 /* Indexed color format, follow LVGL format. */,
  indexed2 = 14,
  indexed4 = 15,
  indexed8 = 16,

  png = 20 /* raw png */,
  jpeg = 21 /* raw jpeg */,
  argb4444 = 24
}
